export default __webpack_public_path__ + "static/media/Whistleblower-grafik.809d75c3.svg";